import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const ProductService = {
    getByProject: async (projectId) => axios.get(API_URL + "/products/by-project/" + projectId).then(({data}) => data).catch((err) => { throw err }),
    getTypes: async () => axios.get(API_URL + "/products/product-types").then((data) => data).catch((err) => { throw err }),
    getDamages: async (projectId) => axios.get(API_URL + "/products/damages/" + projectId).then((data) => data).catch((err) => { throw err }),

    getPlace: async (data) => {
        return axios.post(API_URL + "/products/get/place", data)
            .then(({data}) => data)
            .catch(err => {
                throw err
            });
    },

    saveBatch: async (data) => {
        return axios.post(API_URL + "/products/save", data)
            .then(({data}) => data)
            .catch(err => {
                throw err
            });
    },
    delete: async (id) => axios.delete(API_URL + "/products/" + id).then((data) => data).catch((err) => { throw err }),
    insertOrUpdatePcl: async (ibge, pcl) => axios.post(API_URL + "/products/insert-or-update-pcl", {ibge, pcl}).then(({data}) => data).catch(err => { throw err }),
}

export default ProductService;